import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LockIcon from '@mui/icons-material/Lock';

// Logo imports
import PulseLogoFull from '../assets/PULSE Logo Full.png';
import ClarisLogo from '../assets/claris_logo_transparent[67291746].png';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const user = await login(username, password);
      console.log('Logged in as:', user);
      // Display (wall-board) accounts go straight to the board, report users
      // to KPI Dashboard, everyone else to OBD Sign On (same rule as the
      // DefaultRedirect in App.js).
      if (user.role === 'display') {
        navigate('/display');
      } else if (user.role === 'report') {
        navigate('/kpi-dashboard');
      } else {
        navigate('/obd-sign-on');
      }
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)'
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={6} sx={{ p: 4, borderRadius: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <img
              src={PulseLogoFull}
              alt="PULSE"
              style={{ maxWidth: '100%', height: 'auto', maxHeight: 200 }}
            />
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              margin="normal"
              required
              autoFocus
              autoComplete="username"
              InputProps={{
                sx: { borderRadius: 1 }
              }}
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              required
              autoComplete="current-password"
              InputProps={{
                sx: { borderRadius: 1 }
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading || !username || !password}
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <LockIcon />}
              sx={{ mt: 3, py: 1.5, borderRadius: 1 }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </Box>

        </Paper>

        {/* Footer */}
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 1
          }}
        >
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
            Powered by
          </Typography>
          <img
            src={ClarisLogo}
            alt="Claris AI"
            style={{ height: 36, opacity: 0.8 }}
          />
        </Box>
      </Container>
    </Box>
  );
}

export default Login;
